import { TenantSignupTrigger } from '@/store/enums/tenantSignupTrigger.enum';

export default [
    { id: TenantSignupTrigger.Disabled, value: 'Disabled' },
    { id: TenantSignupTrigger.SignupChatStart, value: 'Signup at chat start' },
    { id: TenantSignupTrigger.SignupLoadComments, value: 'Signup at comments rating' },
    { id: TenantSignupTrigger.SubscribeChatStart, value: 'Subscribe at chat start' },
];
